<!--
 * @Description: 名单库添加
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <table-render
      ref="nameListTableRender"
      :config="config"
      rowKey="userId"
      height="52vh"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
    />
    <div class="footer">
      <span class="select-all" @click="chooseAll">全选</span>
      <div class="footer-button-group">
        <el-button type="primary" @click="confirm" :loading="btLoading">
          确认添加
        </el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { protocolService } from '@/api/ajax';
import { btLoading } from '@/Mixin/btLoading';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';

export default {
  mixins: [btLoading],
  name: 'AddTask19',
  inject: ['indexPage'], // \src\page\project-record\views\task-record\task-list.vue
  props: {
    // 初始外层列表
    searchTheList: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      config: config,
      getUnqualifiedRowConfig,
      selection: []
    };
  },
  components: { tableRender },
  computed: {
    projectId() {
      return this.$store.state.homeProject.id;
    }
  },
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    },
    async chooseAll() {
      await this.$refs.nameListTableRender.selectAllByRowKey({
        listAjax: protocolService.listPeopleByProjectIdALL.bind(null, {
          projectId: this.projectId
        })
      });
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    formatterData(selection) {
      let userInfoList = selection.map(({ userId, taskNum = 1 }) => {
        return {
          userId,
          num: taskNum,
          projectId: this.projectId
        };
      });
      return { list: userInfoList };
    },
    emptyCheck() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一个人员');
        return false;
      }
      return true;
    },
    async confirm() {
      if (!this.emptyCheck()) {
        return;
      }
      this.SET_BTLOADING(true);
      // 该接口单独处理的传参方式
      await protocolService.addTaskNum(this.formatterData(this.selection));
      // 刷新当前列表
      this.$refs.nameListTableRender.saveSuccess();
      this.$refs.nameListTableRender.clearTableSelection();
      this.SET_BTLOADING(false);
      this.$xrkDialog.remove();
      // 刷新最外层列表
      this.indexPage.searchTheList();
    }
  },
  created() {
    this.config[0].childMenu[0].defaultQuery = {
      projectId: this.projectId
    };
    this.$nextTick(() => {
      this.selection = this.$refs.nameListTableRender.$refs.table.selection;
    });
  }
};
</script>

<style scoped lang="scss">
.select-all {
  cursor: pointer;
}
.footer {
  padding: 0 25px;
}
.footer-button-group {
  display: flex;
  justify-content: flex-end;
}
</style>
